module.exports = __webpack_public_path__ + "static/media/aispeak_logo_black-01.8d0a2fc5.svg";